import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { APPEARANCE_MODE_LIGHT } from '@/mui/constants';

import { loadingSelector } from '../redux/selectors';
import useTitle from '@/modules/@common/helpers/hooks/useTitle';
import { getImpersonated } from '@/modules/@common/token/helpers';

import Impersonate from '@/modules/@common/Impersonate';
import ThemeConfig from '@/mui/theme';
import MenuComponent from './menu';
import ProgressDialog from './ProgressDialog/ProgressDialog';

import styles from './index.module.scss';

function LayoutComponent(props) {
  const router = useRouter();
  const [isShowImpersonate, setShowImpersonate] = useState(false);
  const loading = useSelector(loadingSelector);
  const [isShowMenu, setShowMenu] = useState(true);

  const title = useTitle();

  useEffect(() => {
    setShowMenu(window.self === window.top);
    setShowImpersonate(getImpersonated());
  }, [router]);

  return (
    <div data-id="Layout" className={styles.Layout}>
      <Head>
        <title>{title}</title>
      </Head>

      <ThemeConfig ignoreOldThemeStrategy>
        {isShowImpersonate && <Impersonate /> }
        <ProgressDialog />
      </ThemeConfig>

      {isShowMenu && (
        <ThemeConfig
          className={styles.Menu}
          ignoreOldThemeStrategy
          staticAppearance={APPEARANCE_MODE_LIGHT}
        >
          <MenuComponent
            key={router.pathname}
            loading={loading}
          />
        </ThemeConfig>
      )}
      {props.children}
    </div>
  );
}

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutComponent;
